/* eslint-disable no-irregular-whitespace */
import styles from 'components/cases/common/Interview/Interview.module.scss'
import TitleFlex from 'components/cases/common/TitleFlex'
import { useEffect, useRef } from 'react'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import InterviewContents from 'components/cases/common/Interview/InterviewContents'
import { ContentData } from 'components/cases/common/Interview/fragments/type'
gsap.registerPlugin(ScrollTrigger)

const sectionTitle: { title: string; sub_title: string } = {
  title: 'Interview',
  sub_title: 'インタビュー',
}

const contentData: ContentData[][] = [
  [
    {
      type: 'imageWithCaption',
      src: '/images/img/cases/assistantrobo/interview_photo.webp',
      alt: 'インタビュー写真',
      text: (
        <p className={styles.img_text}>
          <span>
            データスタジアム株式会社　配信サービス部 野球アナリスト 小林 展久さん
            <br />
            映像・メディア事業推進部 　営業・新規事業担当 佐藤 一司さん{' '}
          </span>
        </p>
      ),
    },
    { type: 'sectionTitle', text: 'BtoBから、BtoCのビジョン展開を共に歩めるパートナー' },
    {
      type: 'greyBox',
      texts: [
        '従来の野球スコア分析ツールは、野球メディアなどの極めて狭い業界のみで使われるBtoBプロダクトがほとんどでした。それに対してこの「アシスタントロボ」は将来的にBtoC展開を見据えており、デザイン性や使い勝手、データの見やすさを重視したいと考えていました。そのためUXに配慮しながらサービスのコンセプトを一緒に考え、デザイン・開発してくれるパートナーを探しておりました。そんな中、さまざまな最新技術やWebサービスを研究されているアイスリーさんを見つけ、お願いする運びとなりました。',
      ],
    },
    { type: 'sectionTitle', text: '複数の選択肢の提案と細やかな気配りが見られるUX設計' },
    {
      type: 'greyBox',
      texts: [
        '今回、たくさんのトライ＆エラーを重ねることとなりましたが、アイスリーさんには我々が求めるものに対して複数のアウトプットの選択肢をご用意していただけたので、スムーズにプロジェクトを進めることができたと感謝しています。また懸案だったデザインについても現代的に仕上げていただき、ユーザーからも高い評価をいただいています。さらに印象的だったのは導線などのUX設計です。細かい部分に気を配っていただいて、アプリ内で迷子になることがありませんでした。現状はBtoBのプロダクトとはいえ、デジタルリテラシーの高い方ばかりをユーザー想定できるわけではないので、広い層のユーザーが使えるように作っていただけてよかったと感じています。',
      ],
    },
    { type: 'sectionTitle', text: 'これからも共にサービスを構築していきたい' },
    {
      type: 'greyBox',
      texts: [
        'ユーザーからは新機能の要望もいただいており、当面はブラッシュアップを重ねていきたいと考えております。こうしたサービスにゴールはないと考えておりますので、アイスリーさんには今後も改善にお付き合いいただければと思っております。また、当初から考えていた通り、数年後にはBtoC展開として広く野球ファンの方にデータとサービスを提供したいと思っています。その際は、ユーザーに合わせてUIを変えたり、コンテンツを追加したり、様々なプランを用意するなどして、BtoB向けとはまた違うかたちでご提供したいところです。野球は他のスポーツと比べても、打率や防御率、球速など、たくさんの数字が出てくる競技ですので、データで野球を見るようになるとさらに楽しみ方が広く深くなります。そうした”野球の楽しさ”をご提供できるサービスに今後もしていきたいと考えております。',
      ],
    },
  ],
]

const tweenVars: gsap.TimelineVars = {
  y: 50,
  duration: 1,
  opacity: 0,
  ease: Power4.easeOut,
}

const Interview: React.FC = () => {
  const timeline = gsap.timeline()
  const wrapper = useRef<HTMLElement>()
  const image = useRef<HTMLImageElement>()
  const text_container = useRef<HTMLDivElement>()
  // const container = useRef<HTMLDivElement>()

  useEffect(() => {
    timeline.from(image.current, tweenVars, 0.2)
    timeline.from(text_container.current, tweenVars, 0.4)

    ScrollTrigger.create({
      animation: timeline,
      trigger: wrapper.current,
      start: 'top-=100 80%',
      toggleActions: 'play none none reverse',
    })
  }, [])

  return (
    <section className={styles.wrapper} ref={wrapper}>
      <div className={styles.content}>
        <TitleFlex sectionTitle={sectionTitle} />
        <div className={styles.article_container} ref={text_container}>
          <InterviewContents contentData={contentData} />
        </div>
      </div>
    </section>
  )
}

export default Interview
